import { FormatWidth } from '@angular/common';
import { Component, HostBinding, Input, OnInit } from '@angular/core';

const STROKE_WIDTH = 10;
const WIDTH = 132;
const HEIGHT = 83;

@Component({
  selector: 'app-chart-gauge',
  templateUrl: './chart-gauge.component.html',
  styleUrls: ['./chart-gauge.component.scss'],
})
export class ChartGaugeComponent {

  @Input() @HostBinding('style.width') width = 'unset';
  @Input() @HostBinding('style.height') height = 'unset';
  @Input() value: number;
  @Input() date?: Date;

  get viewBox() {
    return `0 0 ${WIDTH} ${HEIGHT}`;
  }

  getArcPath(percent: number) {
    const centerX = WIDTH / 2;
    const halfStroke = STROKE_WIDTH / 2;
    const radius = centerX - halfStroke;

    const startX = centerX;
    const startY = radius + halfStroke;

    const endAngle = 1.8 * Math.max(0, Math.min(100, Number(percent) ?? 0));

    return this.describeArc(startX, startY, radius, 0, endAngle);
  }

  private describeArc(x: number, y: number, radius: number, startAngle: number, endAngle: number) {
    const start = this.polarToCartesian(x, y, radius, endAngle);
    const end = this.polarToCartesian(x, y, radius, startAngle);

    const largeArcFlag = endAngle - startAngle <= 180 ? '0' : '1';

    const d = [
      'M', start.x, start.y,
      'A', radius, radius, 0, largeArcFlag, 0, end.x, end.y
    ].join(' ');

    return d;
  }

  private polarToCartesian(centerX: number, centerY: number, radius: number, angleInDegrees: number) {
    const angleInRadians = (angleInDegrees - 180) * Math.PI / 180.0;

    return {
      x: centerX + (radius * Math.cos(angleInRadians)),
      y: centerY + (radius * Math.sin(angleInRadians))
    };
  }
}
